<template>
  <div class="npos-page">
    <Post post-type="cause" />
  </div>
</template>

<script>
import Close from "../components/UI/Close";
import Post from "../components/Post/Post";
export default {
  name: "Npos",
  components: { Post, Close },
  created() {
    this.$checkAvatar(this.$user("has_avatar"));
  },
  mounted() {
    this.$scrollToTop();
    this.$setState("showGoogleMap", false);
    this.$setState("showAppFilters", false);
  }
};
</script>

<style>
.cause-item__btn {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
